module.exports = __webpack_public_path__ + "img/pro_capture2.b33726a1.png";